import type { ComplexClassName } from '../types/common'

export function classArray(complexClass: ComplexClassName) {
  const cls: string[] = []
  if (!complexClass)
    return cls
  if (typeof complexClass === 'string' || Array.isArray(complexClass))
    return cls.concat(complexClass)

  if (typeof complexClass === 'object') {
    for (const className in complexClass) {
      if ((complexClass)[className])
        cls.push(className)
    }
  }
  return cls
}
